import { render, staticRenderFns } from "./XhStructure.vue?vue&type=template&id=3ed03f99&scoped=true"
import script from "./XhStructure.vue?vue&type=script&lang=js"
export * from "./XhStructure.vue?vue&type=script&lang=js"
import style0 from "./XhStructure.vue?vue&type=style&index=0&id=3ed03f99&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed03f99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed03f99')) {
      api.createRecord('3ed03f99', component.options)
    } else {
      api.reload('3ed03f99', component.options)
    }
    module.hot.accept("./XhStructure.vue?vue&type=template&id=3ed03f99&scoped=true", function () {
      api.rerender('3ed03f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhStructure.vue"
export default component.exports